import { z } from 'zod';

const roleSchema = z.object({
  Id: z.string(),
  Name: z.string(),
  UserRights: z.string(),
  Permissions: z.array(z.string())
});

const departmentSchema = z.object({
  Id: z.string(),
  Name: z.string()
});

const companySchema = z.object({
  Id: z.string(),
  Name: z.string()
});

const userSchema = z.object({
  Id: z.string(),
  Name: z.string(),
  FirstName: z.string(),
  LastName: z.string(),
  Email: z.string(),
  IsActive: z.boolean(),
  IsSystemUser: z.boolean(),
  DepartmentCode: z.string(),
  RankCode: z.string(),
  DutyRankId: z.string(),
  CurrentVesselId: z.string(),
  Roles: z.array(roleSchema),
  Departments: z.array(departmentSchema),
  Companies: z.array(companySchema),
  Positions: z.array(z.unknown()).optional(),
  Vessels: z.array(z.unknown()).optional(),
  Messages: z.array(z.unknown()).optional(),
  Permissions: z.array(z.string()),
  UserRights: z.string(),
  Visibility: z.unknown().optional()
});

export const whoAmISchema = z.object({
  UserName: z.string(),
  Security: z.object({
    UserName: z.string(),
    User: userSchema
  }),
  SiteInformation: z.unknown().optional()
});

export type Role = z.infer<typeof roleSchema>;
export type Department = z.infer<typeof departmentSchema>;
export type User = z.infer<typeof userSchema>;
export type WhoAmIResponse = z.infer<typeof whoAmISchema>;
